import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { MenuItem } from '../../views/TopbarMenu';
import { MenubarContent } from './MenubarContent';
import { MenubarItem } from './MenubarItem';
import { MenubarItemSeparator } from './MenubarItemSeparator';

export const MenubarSubmenu = ({
  item,
  index,
  depth,
  openIndexes,
  setOpenIndexes,
  closeMenu,  
  isDisabled,
}: {
  item: MenuItem;
  index: number;
  depth: number;
  openIndexes: number[];
  setOpenIndexes: Dispatch<SetStateAction<number[]>>;
  closeMenu: () => void;
  isDisabled?: boolean;
}) => {
  return (
    <ItemContainer>
      <MenubarItem
        isDisabled={isDisabled}
        isActive={openIndexes[depth] === index}
        cursorPointer={item.items ? false : true}
        onClick={() => {
          item.onClick && item.onClick();
          if (item.items === undefined && item.closeOnClick !== false) {
            closeMenu();
          }
        }}
        onMouseEnter={() => {
          setOpenIndexes((prev: number[]) => {
            prev[depth] = index;
            prev = prev.slice(0, depth + 1);
            return [...prev];
          });
        }}
      >
        {item.label}
        <RightSlot>
          {item.rightSlot && <div>{item.rightSlot}</div>}
          {item.items && <i className="icon-arrow-right" />}
        </RightSlot>
      </MenubarItem>

      {item.items && (
        <MenubarContent $isOpen={openIndexes[depth] === index} $right>
          {item.items?.map((subItem, subIndex) =>
            subItem.separator ? (
              <MenubarItemSeparator key={`separator-${depth}-${subIndex}`} />
            ) : (
              <MenubarSubmenu
                key={`submenu-${depth}-${subIndex}`}
                item={subItem}
                index={subIndex}
                depth={depth + 1}
                openIndexes={openIndexes}
                setOpenIndexes={setOpenIndexes}
                closeMenu={closeMenu}
              />
            )
          )}
        </MenubarContent>
      )}
    </ItemContainer>
  );
};

const RightSlot = styled.div`
  display: flex;
  margin-left: 5px;

  & > div {
    display: flex;
    opacity: 0.7;
  }

  & > i {
    width: 5px;
    margin-left: 5px;
  }
`;

const ItemContainer = styled.div`
  position: relative;
`;
